import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('BOOKMAKER_LIST');
